import { useEffect, useState } from "react";
import api from "@/api/axios";
import { API } from "@/App";

export function useUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    api
      .get(`${API}/users`)
      .then((r) => setUsers(r.data))
      .catch(() => setUsers([]));
  }, []);
  return users;
}
